import { Icon } from '@/components';

export function ItemIcon({
  color,
  verticalAlign,
}: {
  color?: string;
  title?: string;
  verticalAlign?: string;
}) {
  return (
    <Icon
      style={{ fontSize: '0.6rem', color, verticalAlign: verticalAlign }}
      type="rectangle"
    />
  );
}
